module.exports = __webpack_public_path__ + "img/avatar-69.4d25fadb.png";